export default {
	methods: {
		/**
		 * Redireciona para o login
		 **/
		toLogin() {
			this.$helper.pushRouteTo({ name: 'Login' });
		},

		/**
		 * Redireciona para o login super
		 **/
		toLoginSuper() {
			this.$helper.pushRouteTo({ name: 'LoginSuper' });
		},

		/**
		 * Redireciona para o primeiro acesso
		 **/
		toFirstAccess() {
			this.$helper.pushRouteTo({ name: 'LoginFirst' });
		},

		/**
		 * Redireciona para o primeiro acesso Super
		 **/
		toFirstAccessSuper() {
			this.$helper.pushRouteTo({ name: 'LoginFirstSuper' });
		},

		/**
		 * Redireciona para a verificação do QR Code
		 * @param String urlGToken
		 * @param String username
		 * @param String password
		 * @param Boolean isSuper
		 **/
		toEnableTwoFactorAuthentication(urlGToken, username, password, isSuper = false) {
			this.$helper.pushRouteTo({ name: 'EnableTwoFactorAuthentication', params: { urlGToken: urlGToken, username: username, password: password, isSuper: isSuper } });
		},

		/**
		 * Redireciona para a troca de senha, se for prmeiro acesso enviasse o password, se for do recuperar senha,
		 * enviasse o codeAccess
		 * @param String title
		 * @param String btnLabel
		 * @param String username
		 * @param String password
		 * @param String codeAccess
		 **/
		toResetPassword(title, btnLabel, username, password, codeAccess) {
			this.$helper.pushRouteTo({
				name: 'ResetPassword',
				params: {
					title: title,
					btnLabel: btnLabel,
					username: username,
					password: password,
					codeAccess: codeAccess
				}
			});
		},

		/**
		 * Redireciona para a confirmação de código (Recuperaão de senha)
		 * @param String username
		 * @param String email
		 **/
		toRecoverConfirmCode(username, email) {
			this.$helper.pushRouteTo({ name: 'RecoverConfirmCode', params: {username: username, email: email } });
		},

		/**
		 * Manda para a página, conforme prioridade de acesso
		 **/
		pushRouteToAccessPriority(merchant_number) {
			if (merchant_number == '*') {
				this.$helper.pushRouteTo({ name: 'Super' });
			} else {
				if (this.permission('overviews', 'select')) {
					this.$helper.pushRouteTo({name: 'Overviews'});
				} else if (this.permission('news', 'select')) {
					this.$helper.pushRouteTo({name: 'Dashboard'});
				} else if (this.permission('searchorder', 'select')) {
					this.$helper.pushRouteTo({name: 'SearchOrder'});
				}else if (this.permission('payment', 'select')) {
					this.$helper.pushRouteTo({name: 'Payment'});
				} else {
					//Limpa as informações e desloga o usuário
					this.clearCookies();
					this.message(this.$t("message_title_error"), this.$t("login_no_access"), "error");
				}
			}
		}
	},
}